import * as React from 'react'
import { Platform, Switch } from 'react-native'

import theme from '@theme/Theme'

interface Props {
  disabled?: boolean
  onChange: () => void
  value: boolean
  trackColor?: string
}

// Props react-native-web pour coloration du switch sur web, "oubliée" dans les types
const ACTIVE_THUMB_COLOR = { activeThumbColor: theme.colors.primary }

const Button = ({ disabled = false, onChange, value, trackColor }: Props) => {
  const TRACK_COLORS = {
    true: trackColor || (Platform.OS === 'ios' && !disabled ? theme.colors.primary : theme.colors.background),
    false: trackColor || theme.colors.background,
  }

  return (
    <Switch
      disabled={disabled}
      ios_backgroundColor={disabled ? theme.colors.background : theme.colors.backgroundSecondary}
      onValueChange={onChange}
      trackColor={TRACK_COLORS}
      {...ACTIVE_THUMB_COLOR}
      thumbColor={
        disabled
          ? theme.colors.disableDark
          : Platform.OS === 'android' && value
          ? theme.colors.primary
          : theme.colors.background
      }
      value={value}
    />
  )
}

export default Button
